(function(){
'use strict';

const optionalPrintFields=['orderNo','tracking','address','phone','email','deliveryPlace'];
const MULTIPAGE_THRESHOLD=10;
const FIRST_PAGE_MAX_ROWS=12;
const CONTINUATION_MAX_ROWS=16;
const PRINT_BANNER_KEY='moga_invoice_banner_settings_v1';
function getPrintBannerSettings(){
  const d={enabled:false,src:'',width:150,height:34,x:30,y:132};
  try{Object.assign(d,JSON.parse(localStorage.getItem(PRINT_BANNER_KEY)||'{}'))}catch(e){}
  d.enabled=!!d.enabled;d.src=String(d.src||'');d.width=Math.max(20,Math.min(210,Number(d.width)||150));d.height=Math.max(8,Math.min(297,Number(d.height)||34));d.x=Math.max(0,Math.min(Math.max(0,210-d.width),Number(d.x)||0));d.y=Math.max(0,Math.min(Math.max(0,297-d.height),Number(d.y)||0));
  return d;
}
function createPrintBanner(){
  const d=getPrintBannerSettings();if(!d.enabled||!d.src)return null;
  const img=document.createElement('img');img.className='moga-print-banner';img.src=d.src;img.alt='';img.style.left=d.x+'mm';img.style.top=d.y+'mm';img.style.setProperty('width',d.width+'mm','important');img.style.setProperty('height',d.height+'mm','important');return img;
}
function appendPrintBanner(target){const img=createPrintBanner();if(img&&target)target.appendChild(img)}
function removePrintBanners(){document.querySelectorAll('.moga-print-banner').forEach(x=>x.remove())}

function cleanOptionalPrintFields(){
  optionalPrintFields.forEach(id=>{
    const el=document.getElementById(id);
    if(!el)return;
    if(el.dataset.printPlaceholder===undefined)el.dataset.printPlaceholder=el.getAttribute('placeholder')||'';
    el.setAttribute('placeholder','');
    if(String(el.value||'').trim()==='-'){
      el.dataset.printDash='1';
      el.value='';
    }
  });
}

function restoreOptionalPrintFields(){
  optionalPrintFields.forEach(id=>{
    const el=document.getElementById(id);
    if(!el)return;
    if(el.dataset.printPlaceholder!==undefined){
      el.setAttribute('placeholder',el.dataset.printPlaceholder);
      delete el.dataset.printPlaceholder;
    }
    if(el.dataset.printDash==='1'){
      el.value='-';
      delete el.dataset.printDash;
    }
  });
}

function controlText(el){
  if(!el)return'';
  if(el.tagName==='SELECT'){
    const opt=el.options?.[el.selectedIndex];
    return String(opt?.textContent||'').trim();
  }
  if(el.type==='checkbox'||el.type==='radio')return el.checked?'✓':'';
  return String(el.value??'').trim();
}

/*
  Spausdinimo kopijoje formos laukus paverčiame paprastu tekstu.
  Taip Chrome/PDF nepraranda buyer, kiekio, kainos, select reikšmių ir t. t.
*/
function freezeFormControls(source,clone){
  const srcControls=Array.from(source.querySelectorAll('input,select,textarea'));
  const cloneControls=Array.from(clone.querySelectorAll('input,select,textarea'));

  srcControls.forEach((src,i)=>{
    const dst=cloneControls[i];
    if(!dst)return;

    /* Datos jau turi atskirus #printDate / #printSaleDate span'us. */
    if(src.id==='date'||src.id==='saleDate'){
      dst.remove();
      return;
    }

    if(src.type==='hidden'){
      dst.remove();
      return;
    }

    const span=document.createElement('span');
    span.className=`moga-print-value ${dst.className||''}`.trim();
    if(dst.id)span.dataset.sourceId=dst.id;
    span.textContent=controlText(src);

    /* Tuščias neprivalomas laukas turi likti tikrai tuščias. */
    if(optionalPrintFields.includes(src.id)&&!span.textContent.trim())span.textContent='';

    dst.replaceWith(span);
  });
}

function cloneLive(node){
  const clone=node.cloneNode(true);
  freezeFormControls(node,clone);
  return clone;
}

function invoiceNumberText(){
  const prefix=(document.getElementById('prefix')?.value||'').trim();
  const year=(document.getElementById('year')?.value||'').trim();
  const seq=(document.getElementById('seq')?.value||'').trim();
  return [prefix,year,seq].filter(Boolean).join('-');
}

function invoiceDateText(){
  return (
    document.getElementById('printDate')?.textContent||
    document.getElementById('date')?.value||
    ''
  ).trim();
}

function makeItemsTable(sourceTable,rows){
  const table=sourceTable.cloneNode(false);
  table.removeAttribute('id');
  table.classList.add('moga-print-items');

  const thead=sourceTable.querySelector('thead');
  if(thead)table.appendChild(thead.cloneNode(true));

  const tbody=document.createElement('tbody');
  rows.forEach(row=>tbody.appendChild(cloneLive(row)));
  table.appendChild(tbody);
  return table;
}

function continuationHeader(sheet){
  const wrap=document.createElement('div');
  wrap.className='moga-print-cont-header';

  const logoBox=document.createElement('div');
  logoBox.className='moga-print-cont-logo';
  const logo=sheet.querySelector('#invoiceLogo');
  if(logo){
    const logoClone=logo.cloneNode(true);
    logoClone.removeAttribute('style');
    logoBox.appendChild(logoClone);
  }

  const center=document.createElement('div');
  center.className='moga-print-cont-center';

  const title=(document.getElementById('invoiceTitleText')?.textContent||'SĄSKAITA FAKTŪRA').trim();
  const no=invoiceNumberText();
  const date=invoiceDateText();

  const titleEl=document.createElement('div');
  titleEl.className='moga-print-cont-title';
  titleEl.textContent=title;

  const noEl=document.createElement('div');
  noEl.className='moga-print-cont-no';
  noEl.textContent=`Nr. ${no}`;

  const dateEl=document.createElement('div');
  dateEl.className='moga-print-cont-date';
  dateEl.textContent=`Data ${date}`;

  center.append(titleEl,noEl,dateEl);
  wrap.append(logoBox,center,document.createElement('div'));
  return wrap;
}

function makePage(extraClass){
  const page=document.createElement('section');
  page.className=`moga-print-page ${extraClass||''}`.trim();
  return page;
}

function splitRows(rows){
  /*
    Pirmame lape leidžiame daugiau prekių, nes rekvizitai ten nebespaudžia vietos.
    Jei visų prekių būtų <= FIRST_PAGE_MAX_ROWS, vis tiek paliekame bent 1 prekę
    paskutiniam lapui kartu su pristatymu/sumomis/rekvizitais, kad neliktų
    beveik tuščio antro lapo vien tik su apačia.
  */
  const firstCount = rows.length <= FIRST_PAGE_MAX_ROWS
    ? Math.max(MULTIPAGE_THRESHOLD, rows.length - 1)
    : FIRST_PAGE_MAX_ROWS;

  const groups=[rows.slice(0,firstCount)];
  let rest=rows.slice(firstCount);
  while(rest.length){
    groups.push(rest.slice(0,CONTINUATION_MAX_ROWS));
    rest=rest.slice(CONTINUATION_MAX_ROWS);
  }
  return groups;
}

function hasRealDiscount(){
  const type=document.getElementById('discountType')?.value||'none';
  const value=Number(document.getElementById('discountValue')?.value||0);
  return type!=='none'&&value>0;
}

function buildMultipagePrint(){
  const sheet=document.getElementById('invoiceSheet');
  if(!sheet)return false;

  const sourceTable=sheet.querySelector('#itemsTable');
  if(!sourceTable)return false;

  const rows=Array.from(sourceTable.querySelectorAll('tbody > tr')).filter(row=>{
    const name=row.querySelector('.iname');
    return !name||String(name.value||name.textContent||'').trim()!=='';
  });

  if(rows.length<=MULTIPAGE_THRESHOLD)return false;

  removeMultipagePrint();

  const pagesWrap=document.createElement('main');
  pagesWrap.id='mogaPrintPages';

  const groups=splitRows(rows);

  groups.forEach((group,index)=>{
    const isFirst=index===0;
    const isLast=index===groups.length-1;
    const page=makePage(isFirst?'moga-print-first':'moga-print-continuation');

    if(isFirst){
      const top=sheet.querySelector('.top');
      const customer=sheet.querySelector('.customer');
      if(top)page.appendChild(cloneLive(top));
      if(customer)page.appendChild(cloneLive(customer));
    }else{
      page.appendChild(continuationHeader(sheet));
    }

    const sectionTitle=sheet.querySelector('.section-title');
    if(sectionTitle)page.appendChild(sectionTitle.cloneNode(true));
    page.appendChild(makeItemsTable(sourceTable,group));

    if(isLast){
      const delivery=sheet.querySelector('.moga-delivery-section');
      const totals=sheet.querySelector('.totals');
      const footer=sheet.querySelector('.bottom-fixed');

      if(delivery)page.appendChild(cloneLive(delivery));
      if(totals)page.appendChild(cloneLive(totals));
      if(footer)page.appendChild(cloneLive(footer));
      page.classList.add('moga-print-last');
    }

    appendPrintBanner(page);
    pagesWrap.appendChild(page);
  });

  document.body.appendChild(pagesWrap);
  document.body.classList.add('moga-custom-print');
  return true;
}

function removeMultipagePrint(){
  document.body.classList.remove('moga-custom-print');
  document.getElementById('mogaPrintPages')?.remove();
}

function buildPrintPreviewPage(){
  const sheet=document.getElementById('invoiceSheet');if(!sheet)return null;
  const sourceTable=sheet.querySelector('#itemsTable');if(!sourceTable)return null;
  const rows=Array.from(sourceTable.querySelectorAll('tbody > tr')).filter(row=>{const name=row.querySelector('.iname');return !name||String(name.value||name.textContent||'').trim()!==''});
  const page=makePage('moga-print-first moga-print-preview-page');
  const top=sheet.querySelector('.top'),customer=sheet.querySelector('.customer');if(top)page.appendChild(cloneLive(top));if(customer)page.appendChild(cloneLive(customer));
  const title=sheet.querySelector('.section-title');if(title)page.appendChild(title.cloneNode(true));
  const previewRows=rows.length>MULTIPAGE_THRESHOLD?splitRows(rows)[0]:rows;page.appendChild(makeItemsTable(sourceTable,previewRows));
  if(rows.length<=MULTIPAGE_THRESHOLD){const delivery=sheet.querySelector('.moga-delivery-section'),totals=sheet.querySelector('.totals'),footer=sheet.querySelector('.bottom-fixed');if(delivery)page.appendChild(cloneLive(delivery));if(totals)page.appendChild(cloneLive(totals));if(footer)page.appendChild(cloneLive(footer));page.classList.add('moga-print-last')}
  return page;
}
window.MOGA_BUILD_PRINT_PREVIEW_PAGE=buildPrintPreviewPage;

function ensurePrintStyles(){
  document.getElementById('mogaSfMultipagePrintCss')?.remove();

  const style=document.createElement('style');
  style.id='mogaSfMultipagePrintCss';
  style.textContent=`
#mogaPrintPages{display:none}
.moga-print-banner{display:none}

@media print{
  @page{size:A4;margin:0!important}

  html,
  body.moga-custom-print{
    width:auto!important;
    min-width:0!important;
    height:auto!important;
    min-height:0!important;
    margin:0!important;
    padding:0!important;
    background:#fff!important;
    overflow:visible!important;
  }

  body.moga-custom-print > *:not(#mogaPrintPages){display:none!important}

  body.moga-custom-print #mogaPrintPages{
    display:block!important;
    width:210mm!important;
    height:auto!important;
    min-height:0!important;
    margin:0!important;
    padding:0!important;
    background:#fff!important;
    overflow:visible!important;
  }

  body.moga-custom-print #mogaPrintPages,
  body.moga-custom-print #mogaPrintPages *{box-sizing:border-box!important}

  .moga-print-banner{
    display:block!important;
    position:absolute!important;
    z-index:25!important;
    max-width:none!important;
    object-fit:fill!important;
    margin:0!important;
    padding:0!important;
    border:0!important;
    box-shadow:none!important;
    filter:none!important;
    opacity:1!important;
    pointer-events:none!important;
  }

  /* 296 mm sąmoningai: Chrome nebeįterpia tuščio lapo dėl A4 apvalinimo. */
  body.moga-custom-print .moga-print-page{
    display:block!important;
    width:210mm!important;
    height:296mm!important;
    min-height:296mm!important;
    max-height:296mm!important;
    margin:0!important;
    padding:14mm 12mm 46mm!important;
    position:relative!important;
    overflow:hidden!important;
    background:#fff!important;
    color:#111!important;
    border:0!important;
    outline:0!important;
    border-radius:0!important;
    box-shadow:none!important;
    filter:none!important;
    break-inside:avoid!important;
    page-break-inside:avoid!important;
    break-after:page!important;
    page-break-after:always!important;
  }

  body.moga-custom-print .moga-print-page:last-child{
    break-after:auto!important;
    page-break-after:auto!important;
  }

  body.moga-custom-print .moga-print-page .screen-only,
  body.moga-custom-print .moga-print-page .row-delete,
  body.moga-custom-print .moga-print-page .product-drop-mark,
  body.moga-custom-print .moga-print-page .client-drop-mark{
    display:none!important;
  }

  body.moga-custom-print .moga-print-value{
    display:inline-block!important;
    color:#111!important;
    -webkit-text-fill-color:#111!important;
    background:transparent!important;
    border:0!important;
    outline:0!important;
    box-shadow:none!important;
    min-height:0!important;
    white-space:pre-wrap!important;
  }

  /* ===== PIRMAS LAPAS: tas pats SF išdėstymas ===== */
  body.moga-custom-print .moga-print-first .top{
    display:grid!important;
    grid-template-columns:38% 62%!important;
    min-height:54mm!important;
  }

  body.moga-custom-print .moga-print-first .top .logo{
    width:60mm!important;
    height:60mm!important;
    max-width:60mm!important;
    max-height:60mm!important;
    object-fit:contain!important;
    margin-left:-1mm!important;
    margin-top:-9mm!important;
  }

  body.moga-custom-print .moga-print-first .title{text-align:right!important}
  body.moga-custom-print .moga-print-first .title h1{font-size:24px!important;margin:0 0 6px!important;font-weight:800!important}

  body.moga-custom-print .moga-print-first .invoice-no{
    font-size:16px!important;
    font-weight:800!important;
    margin-bottom:22px!important;
    display:flex!important;
    align-items:center!important;
    justify-content:flex-end!important;
    gap:3px!important;
    flex-wrap:wrap!important;
  }

  body.moga-custom-print .moga-print-first .invoice-no .moga-print-value{
    width:auto!important;
    min-width:0!important;
    text-align:center!important;
    font-weight:800!important;
  }

  body.moga-custom-print .moga-print-first .meta{
    margin-left:auto!important;
    width:76mm!important;
    border-collapse:collapse!important;
    font-size:13px!important;
  }

  body.moga-custom-print .moga-print-first .meta td{padding:2px 0!important;vertical-align:middle!important}
  body.moga-custom-print .moga-print-first .meta td:first-child{width:34mm!important;text-align:left!important;white-space:nowrap!important;padding-right:8px!important}

  body.moga-custom-print .moga-print-first .customer{
    margin-top:2mm!important;
    font-size:13px!important;
    width:100%!important;
    border-collapse:collapse!important;
  }
  body.moga-custom-print .moga-print-first .customer td{padding:3px 0!important;vertical-align:middle!important}
  body.moga-custom-print .moga-print-first .customer td:first-child{width:29mm!important;font-weight:700!important}
  body.moga-custom-print .moga-print-first .customer .moga-print-value{font-style:italic!important;width:auto!important;max-width:100%!important}
  body.moga-custom-print .moga-print-first .customer .client-input-wrap{display:inline!important}

  /* ===== BENDRA PREKIŲ LENTELĖ ===== */
  body.moga-custom-print .moga-print-page .section-title{
    margin:16mm 0 7mm!important;
    text-align:center!important;
    font-weight:800!important;
    font-size:14px!important;
  }

  body.moga-custom-print .moga-print-page table.items{
    width:100%!important;
    border-collapse:collapse!important;
    table-layout:fixed!important;
    font-size:13px!important;
    break-inside:auto!important;
    page-break-inside:auto!important;
  }

  body.moga-custom-print .moga-print-page table.items thead{display:table-header-group!important}
  body.moga-custom-print .moga-print-page table.items tr{break-inside:avoid!important;page-break-inside:avoid!important}
  body.moga-custom-print .moga-print-page table.items th{border:1px solid #111!important;padding:4px!important;text-align:center!important;font-weight:800!important}
  body.moga-custom-print .moga-print-page table.items td{
    border-left:1px dashed #111!important;
    border-right:1px dashed #111!important;
    border-bottom:1px dashed #111!important;
    height:26px!important;
    padding:2px 4px!important;
    vertical-align:middle!important;
  }
  body.moga-custom-print .moga-print-page table.items tbody tr:first-child td{border-top:1px dashed #111!important}
  body.moga-custom-print .moga-print-page table.items td:nth-child(n+2){text-align:center!important}
  body.moga-custom-print .moga-print-page table.items .moga-print-value{width:100%!important;text-align:inherit!important}
  body.moga-custom-print .moga-print-page table.items .iname{line-height:1.28!important}
  body.moga-custom-print .moga-print-page table.items .itotal{white-space:nowrap!important}

  /*
    Gyvoje SF lentelėje stulpelių plotį keičia pagrindinės temos CSS.
    Po Mat. vnt. įterpimo lentelė turi 6 stulpelius, todėl senos 5 stulpelių
    !important taisyklės print'e nustumdavo "Viso" už lentelės ribų.
    Čia print kopijai aiškiai paskirstome VISUS 6 stulpelius iki 100%.
  */
  body.moga-custom-print .moga-print-page table.items th:nth-child(1),
  body.moga-custom-print .moga-print-page table.items td:nth-child(1){width:46%!important}
  body.moga-custom-print .moga-print-page table.items th:nth-child(2),
  body.moga-custom-print .moga-print-page table.items td:nth-child(2){width:9%!important}
  body.moga-custom-print .moga-print-page table.items th:nth-child(3),
  body.moga-custom-print .moga-print-page table.items td:nth-child(3){width:11%!important}
  body.moga-custom-print .moga-print-page table.items th:nth-child(4),
  body.moga-custom-print .moga-print-page table.items td:nth-child(4){width:14%!important}
  body.moga-custom-print .moga-print-page table.items th:nth-child(5),
  body.moga-custom-print .moga-print-page table.items td:nth-child(5){width:10%!important}
  body.moga-custom-print .moga-print-page table.items th:nth-child(6),
  body.moga-custom-print .moga-print-page table.items td:nth-child(6){width:10%!important}

  body.moga-custom-print .moga-print-page table.items tbody td:last-child{
    position:relative!important;
    padding-left:4px!important;
    padding-right:4px!important;
    white-space:nowrap!important;
    overflow:hidden!important;
  }
  body.moga-custom-print .moga-print-page table.items tbody td:last-child .itotal{
    display:block!important;
    min-width:0!important;
    width:100%!important;
    text-align:center!important;
  }

  /* ===== TĘSINIO LAPAI ===== */
  body.moga-custom-print .moga-print-continuation{padding-top:10mm!important}

  body.moga-custom-print .moga-print-continuation .moga-print-cont-header{
    display:grid!important;
    grid-template-columns:38mm 1fr 38mm!important;
    align-items:start!important;
    width:100%!important;
    min-height:39mm!important;
  }

  body.moga-custom-print .moga-print-cont-logo{
    display:flex!important;
    align-items:flex-start!important;
    justify-content:center!important;
  }

  body.moga-custom-print .moga-print-cont-logo #invoiceLogo,
  body.moga-custom-print .moga-print-cont-logo .logo{
    width:29mm!important;
    height:29mm!important;
    max-width:29mm!important;
    max-height:29mm!important;
    object-fit:contain!important;
    margin:0!important;
  }

  body.moga-custom-print .moga-print-cont-center{
    text-align:center!important;
    padding-top:1mm!important;
    color:#000!important;
  }

  body.moga-custom-print .moga-print-cont-title{
    font-size:21px!important;
    line-height:1.15!important;
    font-weight:900!important;
    margin:0 0 3mm!important;
  }

  body.moga-custom-print .moga-print-cont-no,
  body.moga-custom-print .moga-print-cont-date{
    font-size:12px!important;
    line-height:1.5!important;
    font-weight:700!important;
  }

  body.moga-custom-print .moga-print-continuation .section-title{margin:10mm 0 5mm!important}

  /* ===== PASKUTINIO LAPO APAČIA ===== */
  body.moga-custom-print .moga-print-last .moga-delivery-section{
    margin-top:7mm!important;
    break-inside:avoid!important;
    page-break-inside:avoid!important;
  }

  body.moga-custom-print .moga-print-last .moga-delivery-title{
    text-align:center!important;
    font-weight:800!important;
    margin-bottom:2mm!important;
  }

  body.moga-custom-print .moga-print-last .moga-delivery-table{width:100%!important;border-collapse:collapse!important}
  body.moga-custom-print .moga-print-last .moga-delivery-table td{border:1px solid #111!important;padding:5px 8px!important}
  body.moga-custom-print .moga-print-last .moga-delivery-price-cell{text-align:center!important;font-weight:800!important;width:32mm!important}

  /* Nuolaidos valdymo laukų į PDF nekeliame. Jei nuolaida reali, ją jau rodo totals lentelės "Nuolaida" eilutė. */
  body.moga-custom-print .moga-print-last .invoice-adjustments{display:none!important}

  body.moga-custom-print .moga-print-last .totals{
    width:32%!important;
    margin:5mm 0 0 auto!important;
    border-collapse:collapse!important;
    font-size:13px!important;
    font-weight:800!important;
    break-inside:avoid!important;
    page-break-inside:avoid!important;
  }

  body.moga-custom-print .moga-print-last .totals td{border:1px solid #111!important;padding:5px 8px!important;text-align:center!important}

  body.moga-custom-print .moga-print-page .bottom-fixed{
    display:block!important;
    position:absolute!important;
    left:12mm!important;
    right:12mm!important;
    bottom:11mm!important;
    margin:0!important;
    break-inside:avoid!important;
    page-break-inside:avoid!important;
  }

  body.moga-custom-print .moga-print-page .footer-note{
    margin:0!important;
    text-align:center!important;
    font-size:11px!important;
    font-style:italic!important;
  }

  body.moga-custom-print .moga-print-page .footer{
    margin-top:9mm!important;
    display:grid!important;
    grid-template-columns:1fr 1fr!important;
    gap:3mm!important;
    font-size:12px!important;
    font-style:italic!important;
    line-height:1.7!important;
  }

  body.moga-custom-print .moga-print-page .footer .right{text-align:right!important}

  /* Tik realūs placeholderiai paslepiami; užpildyti rekvizitai rodomi. */
  body.moga-custom-print .moga-print-page .seller-placeholder{visibility:hidden!important}

  body.moga-custom-print .moga-print-page #printDate,
  body.moga-custom-print .moga-print-page #printSaleDate{display:inline!important}
}
`;
  document.head.appendChild(style);
}

ensurePrintStyles();

window.addEventListener('beforeprint',()=>{
  cleanOptionalPrintFields();
  removePrintBanners();
  const multipage=buildMultipagePrint();
  if(!multipage)appendPrintBanner(document.getElementById('invoiceSheet'));
});

window.addEventListener('afterprint',()=>{
  removePrintBanners();
  removeMultipagePrint();
  restoreOptionalPrintFields();
});

document.addEventListener('click',e=>{
  const btn=e.target.closest('button');
  if(!btn)return;
  const txt=(btn.textContent||'').toLowerCase();
  if(txt.includes('spausdinti')||txt.includes('save pdf'))cleanOptionalPrintFields();
},true);

})();
